module.exports = __webpack_public_path__ + "img/04.99e7e59d.png";